document.addEventListener('DOMContentLoaded', function(){
  /* Ambient water droplet background with scroll parallax */
  if (!document.querySelector('.pwg-droplets-bg')) {
    var bg = document.createElement('div');
    bg.className = 'pwg-droplets-bg';
    bg.setAttribute('aria-hidden', 'true');
    var COUNT = 32;
    for (var i = 0; i < COUNT; i++) {
      var d = document.createElement('span');
      var r = Math.random();
      d.className = 'pwg-drop' + (r < 0.22 ? ' lg' : (r > 0.78 ? ' sm' : ''));
      // streak height: small/medium/large droplets each have their own length range
      var height = r < 0.22 ? (60 + Math.random() * 80) : (r > 0.78 ? (25 + Math.random() * 30) : (40 + Math.random() * 55));
      d.style.height = height + 'px';
      d.style.left = (Math.random() * 100) + '%';
      d.style.top = (Math.random() * 140 - 20) + '%';
      d.dataset.speed = (0.2 + Math.random() * 0.55).toFixed(2);
      bg.appendChild(d);
    }
    document.body.appendChild(bg);

    var drops = bg.querySelectorAll('.pwg-drop');
    var ticking = false;
    var onScroll = function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var y = window.pageYOffset || document.documentElement.scrollTop;
        for (var i = 0; i < drops.length; i++) {
          var sp = parseFloat(drops[i].dataset.speed) || 0.3;
          drops[i].style.transform = 'translate3d(0,' + (y * sp) + 'px,0)';
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Quantity stepper */
  document.querySelectorAll('.pwg-qty').forEach(function(group){
    var input = group.querySelector('.pwg-qty-input');
    var dec = group.querySelector('[data-qty-step="-1"]');
    var inc = group.querySelector('[data-qty-step="1"]');
    if (!input) return;
    var clamp = function(v){ v = parseInt(v,10); if (isNaN(v) || v < 1) v = 1; return v; };
    var sync = function(){
      input.value = clamp(input.value);
      if (dec) dec.disabled = parseInt(input.value,10) <= 1;
    };
    if (dec) dec.addEventListener('click', function(){ input.value = clamp(parseInt(input.value,10) - 1); sync(); });
    if (inc) inc.addEventListener('click', function(){ input.value = clamp(parseInt(input.value,10) + 1); sync(); });
    input.addEventListener('input', sync);
    input.addEventListener('blur', sync);
    sync();
  });

  /* Hero gallery: swipe carousel with dot pagination */
  document.querySelectorAll('.pwg-product-gallery').forEach(function(gallery){
    var track = gallery.querySelector('[data-pwg-gallery]');
    var dots = gallery.querySelectorAll('[data-pwg-dot]');
    if (!track || dots.length === 0) return;

    var slides = track.querySelectorAll('.pwg-gallery-slide');

    var setActive = function(idx){
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
    };

    var current = 0;
    var ticking = false;
    var onScroll = function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var width = track.clientWidth;
        if (width > 0) {
          var idx = Math.round(track.scrollLeft / width);
          if (idx !== current) {
            current = idx;
            setActive(idx);
          }
        }
        ticking = false;
      });
    };
    track.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function(dot, i){
      dot.addEventListener('click', function(){
        var width = track.clientWidth;
        track.scrollTo({ left: width * i, behavior: 'smooth' });
        current = i;
        setActive(i);
      });
    });

    /* Keep dot state correct on resize */
    window.addEventListener('resize', function(){
      onScroll();
    });
  });
});
